import Logger from "./lib/logger";
import "./partials/SvgIcon";
import "./partials/DimensionalSelect";
import "./partials/CustomSizeForm";

const NAME = "Product";

function init() {
	Logger.info(`${NAME} > init`);
}

init();
